import React from 'react';
import SectionContainer from 'components/Containers/SectionContainer';
import Label from 'components/form/Label/Label';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import ActionsYouCanTake from '../../components/ActionsYouCanTake/ActionsYouCanTake';
import { Row } from 'components/Containers/Row/Row';
import FrequentlyAskedQuestions from 'components/FrequentlyAskedQuestions/FrequentlyAskedQuestions';

const frequentlyAskedQuestion = [
  {
    question:
      "What if I can't afford to make the minimum payment before the 30-day deadline?",
    answer: `
        <ul>
            <li>Contact your credit card, and explain. Then ask for what you need:</li>
            <li>Will they accept a partial payment without reporting you late? They might if you also explain how you’ll make up the shortfall.</li>
            <li>Perhaps all you need is a change to your due date. Ask them to move it out so you can cover it in full with your next paycheck.</li>
            <li>If you have an exemplary history, you might convince them to let you skip one payment without reporting you as delinquent. Or at least reporting only a single late payment rather than the “rolling” lates that happen when you get a month behind and can’t catch up.</li>
        </ul>
        `,
  },
  {
    question: 'What if I am 30 days late?',
    answer:
      'Payments more than 30 days past due are generally reported as late to credit bureaus. If you have a good history with the company, you can still try contacting them by phone to apologize, pay your bill and ask them to please report your payment on time. Alternatively, you can pay your bill and send a goodwill letter explaining, apologizing, reminding them that you’re a great customer and asking them to report your payment as on time.',
  },
  {
    question: 'What if I am 60 days late?',
    answer:
      'Whether or not the company agrees to report your payment as on time, it’s critical that you catch up before you’re 60 days late. A 60-day late payment on your credit report is a serious matter and can drop your credit score significantly. In addition, many credit card companies impose penalty rates, which may be much higher than your regular interest rate once you go 60 days past due. And it can stay that way for six months after you catch up and resume paying on time.',
  },
];

const actionsYouCanTake = [
  {
    title: 'Make it automatic',
    subtitle:
      'The easiest way to avoid late payments on credit cards is to set up automatic reminders or payments. Once you do that, your credit card company texts or emails you before a payment is due so you can view your statement and decide how much you want to pay – the minimum, current balance, statement balance or some other amount. You can also choose to automatically pay the minimum each month so you’re never late, and then manually pay more on a date that you choose.',
    takeTip: {
      tipContent:
        'If your issue is difficulty affording your monthly payment, ask to shift your due date so that it doesn’t coincide with other bills like rent or an auto loan.',
    },
  },
  {
    title: 'Negotiate with your creditors',
    subtitle:
      'Contact creditors and tell them you want to pay and appreciate any flexibility they can offer.  They may be willing to give you more time to pay.  Ask them if it is possible to reduce their interest rates. This does not reduce your debt, but can slow the pace at which interest and penalties add to it.',
    isSimpleAction: true,
  },
];

const AccountNowCurrentNotificationView = props => {
  return (
    <SectionContainer className="cmAlertsDetailsContainer notificationsAlertsDetails">
      <Row className="text-28 fontLatoNormal700 margB16">
        <Label type="H4" typeHeader="h2">
          Account Now Current
        </Label>
      </Row>
      <Row className="text-28 fontLatoNormal700 margB16">
        <Label className="caption system_neutral_n300_text">
          {`Reported on ${props.alertDetailsConfig?.date} by `}
          {props?.bureauLogo[props.selectedAlertDetails?.alertProvider]}
        </Label>
      </Row>
      <Row className="text-28 fontLatoNormal700 margB16">
        <Label type="H4" typeHeader="h3">
          Kudos! Catching it before the 30-day mark may have minimized any
          damage to your credit score.
        </Label>
      </Row>
      <Row>
        <FlexContainer column>
          <Label type="Body1" className="mBody-2">
            Account status changes can take time to appear on your credit
            reports. Check for updates regularly.
          </Label>
          <Label bold className="Body1 margTB8">
            The following account is now current
          </Label>
          {props?.selectedAlertDetails?.alertDetails?.currentTradeLines?.map(
            tradeline => (
              <div className="margb16" key={tradeline?.tradeLineIdHash}>
                <Label bold className="Body-2 toUpper">
                  ACCOUNT
                </Label>
                <Label className="Body-2 toUpper margb8">
                  {tradeline?.tradeLineName}
                </Label>
                <Label bold className="Body-2 toUpper">
                  PAST DUE BALANCE
                </Label>
                <Label type="Body-2">$ {tradeline?.amountPastDue}</Label>
              </div>
            ),
          )}
        </FlexContainer>
      </Row>
      <div className="padTB4 bgGrey005"></div>
      <Row>
        <ActionsYouCanTake
          {...props}
          title="How to avoid future late payments on credit cards"
          subTitle="Here are a few tips for keeping your account current in the future."
          actionsYouCanTake={actionsYouCanTake}
        />
      </Row>
      <div className="padTB4 bgGrey005"></div>
      <Row className="padt20">
        <FrequentlyAskedQuestions
          frequentlyAskedQuestion={frequentlyAskedQuestion}
        />
      </Row>
    </SectionContainer>
  );
};

export default AccountNowCurrentNotificationView;
